function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import vent from 'elements/vent';
import { fetchOrAbort } from 'elements/utils';
import flatpickr from 'flatpickr/dist/flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import tippy from 'tippy.js';
import 'tom-select/dist/css/tom-select.css';
import TomSelect from 'tom-select';
export var offreForm = new (/*#__PURE__*/function () {
  function OffreForm() {
    var _this = this;
    _classCallCheck(this, OffreForm);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
    vent.on('DIALOG:OPEN', function (_) {
      document.querySelectorAll('form[data-auto-submit-interval]').forEach(function (form) {
        if (form.timeout) {
          clearTimeout(form.timeout);
          form.timeout = null;
        }
      });
    });
    vent.on('DIALOG:CLOSE', function (_) {
      document.querySelectorAll('form[data-auto-submit-interval]').forEach(_this.onAutoSubmitInterval);
    });
    document.addEventDelegate('click', this.onForceSaveResponses.bind(this), '#form-single-responses [type="submit"]');
    document.addEventDelegate('change', this.onReloadChange.bind(this), '[data-reload-change]');
    document.addEventDelegate('change', this.onResponseChoosen.bind(this), '[data-input="response"]');
    document.addEventDelegate('change', function (e) {
      _this.onTogglerChange(e.target);
    }, '[data-toggler]');
  }
  return _createClass(OffreForm, [{
    key: "init",
    value: function init() {
      document.querySelectorAll('[data-toggler]').forEach(this.onTogglerChange);
      document.querySelectorAll('form[data-auto-submit-interval]').forEach(this.onAutoSubmitInterval);
    }
  }, {
    key: "onReloadChange",
    value: function onReloadChange(e) {
      var url = e.target.getAttribute('data-reload-change');
      var form = e.target.closest('form');
      var action = form.getAttribute('action');

      // Désactive temporairement la validation
      form.setAttribute('novalidate', true);
      form.setAttribute('action', url);
      // Soumet le formulaire sans validation
      form.requestSubmit();
      form.removeAttribute('novalidate');
      form.setAttribute('action', action);

      // window.fetchFajax(url);
    }
  }, {
    key: "onTogglerChange",
    value: function onTogglerChange(toggler) {
      console.log('toggler', toggler);
      var checked = toggler.checked;
      var value = toggler.getAttribute('data-toggler');
      var container = toggler.closest('[data-toggler-container]');
      if (!container) return;
      container.querySelectorAll('[data-toggler-target]').forEach(function (target) {
        if (target.getAttribute('data-toggler-target') == value && checked) {
          target.classList.remove('is-hidden');
          target.removeAttribute('disabled');
        } else {
          target.classList.add('is-hidden');
          target.setAttribute('disabled', 'disabled');
        }
      });
    }
  }, {
    key: "onResponseChoosen",
    value: function onResponseChoosen(e) {
      var form = document.querySelector('form#' + e.target.getAttribute('form'));
      if (form) {
        form.requestSubmit();
      }
    }
  }, {
    key: "onForceSaveResponses",
    value: function onForceSaveResponses(e) {
      e.preventDefault();
      var form = document.querySelector('form#' + e.target.getAttribute('form'));
      if (form.querySelector('input[name="save_button"]')) {
        form.querySelector('input[name="save_button"]').value = 'manual';
      }
      if (form) {
        form.requestSubmit();
      }
    }
  }, {
    key: "onAutoSubmitInterval",
    value: function onAutoSubmitInterval(form) {
      if (form.timeout) {
        clearTimeout(form.timeout);
        form.timeout = null;
      }
      form.timeout = setTimeout(function (_) {
        form.requestSubmit();
      }, form.getAttribute('data-auto-submit-interval') * 1000);
    }
  }]);
}())();